import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=3fcf89ec&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=3fcf89ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf89ec",
  null
  
)

export default component.exports